import { Grid } from '@material-ui/core';
import i18n from 'i18n';
import { EnvironmentBehaviorFieldsProps } from 'modules/environments/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import TitleBehavior from '../TitleBehavior';
import PeriodCard from './PeriodCard';

interface FormPeriodsProps {
  environmentBehaviorWeek: EnvironmentBehaviorFieldsProps;
  environmentBehaviorSaturday: EnvironmentBehaviorFieldsProps;
  environmentBehaviorSunday: EnvironmentBehaviorFieldsProps;
  mode: string;
  setBehaviorSaturday: React.Dispatch<
    React.SetStateAction<EnvironmentBehaviorFieldsProps>
  >;
  setBehaviorSunday: React.Dispatch<
    React.SetStateAction<EnvironmentBehaviorFieldsProps>
  >;
  setBehaviorWeek: React.Dispatch<
    React.SetStateAction<EnvironmentBehaviorFieldsProps>
  >;
  setHasError: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormPeriods = ({
  environmentBehaviorSaturday,
  environmentBehaviorSunday,
  environmentBehaviorWeek,
  mode,
  setBehaviorSaturday,
  setBehaviorSunday,
  setBehaviorWeek,
  setHasError,
}: FormPeriodsProps) => {
  const [hasErrorBehaviorWeek, setHasErrorBehaviorWeek] = React.useState(false);
  const [
    hasErrorBehaviorSaturday,
    setHasErrorBehaviorSaturday,
  ] = React.useState(false);
  const [hasErrorBehaviorSunday, setHasErrorBehaviorSunday] = React.useState(
    false
  );

  React.useEffect(() => {
    setHasError(
      hasErrorBehaviorWeek || hasErrorBehaviorSaturday || hasErrorBehaviorSunday
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasErrorBehaviorWeek, hasErrorBehaviorSaturday, hasErrorBehaviorSunday]);

  return (
    <Grid item xs={12}>
      <TitleBehavior
        title={i18n.t('DEFINE_PERIODS_TITLE_KEY')}
        subtitle={i18n.t('DEFINE_PERIODS_SUBTITLE_KEY')}
      />

      <Grid container spacing={3} xs={12}>
        <PeriodCard
          id="toggle-week-period"
          initialValues={environmentBehaviorWeek}
          mode={mode}
          title={i18n.t('IN_THE_WEEK_KEY')}
          setBehavior={setBehaviorWeek}
          setHasError={setHasErrorBehaviorWeek}
        />
        <PeriodCard
          id="toggle-saturday-period"
          initialValues={environmentBehaviorSaturday}
          mode={mode}
          title={i18n.t('ON_THE_SATURDAY_KEY')}
          setBehavior={setBehaviorSaturday}
          setHasError={setHasErrorBehaviorSaturday}
        />
        <PeriodCard
          id="toggle-sunday-period"
          initialValues={environmentBehaviorSunday}
          mode={mode}
          title={i18n.t('ON_THE_SUNDAY_KEY')}
          setBehavior={setBehaviorSunday}
          setHasError={setHasErrorBehaviorSunday}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: {
    environmentBehaviorWeek,
    environmentBehaviorSaturday,
    environmentBehaviorSunday,
  },
}: ApplicationState) => ({
  environmentBehaviorWeek,
  environmentBehaviorSaturday,
  environmentBehaviorSunday,
});

export default connect(mapStateToProps, {})(FormPeriods);
